// extracted by mini-css-extract-plugin
module.exports = {"box":"SecondStep_box__3-QHq","label":"SecondStep_label__Wtdef"};